{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Nová správa",
  "chat.scrollToBottom": "Prejdite na koniec",
  "messagefeedback.thumbDown": "Zlá odozva",
  "messagefeedback.thumbUp": "Dobrá odozva",
  "promptfield.aiDisclaimer": "Odpovede sú generované pomocou AI a môžu byť nepresné. Pred použitím si skontrolujte.",
  "promptfield.aiUserGuidlines": "Pokyny pre používateľov AI",
  "promptfield.attachments": "Prílohy",
  "promptfield.insertButton": "Pridať",
  "promptfield.label": "Zadanie",
  "promptfield.placeholder": "Ste pripravení začať? Položte otázku, podeľte sa o nápad alebo pridajte úlohu.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Odoslať",
  "promptfield.uploading": "Nahrávanie",
  "responsestatus.loading": "Načítava sa",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Začni nahrávať",
  "voicebutton.stopListening": "Zastavte nahrávanie",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
